<template>
  <div class="newsListDetail">
      <article class="eq-header" :model="newList">
          <h4>{{newList.title}}</h4>
          <p v-html="newList.describe"></p>
          <div>
             
          </div>
         <img v-bind:src="newList.img_url" alt="">
      </article>
      <br>
      <br>
      <br>
  </div>
</template>

<script>
export default {
  name: 'newsListDetail',
  props:["message","id"],
  data () {
    return {
      Index:this.message,
      newList:{
        title:'',
        describe:'',
        img_url:''
      }
    }
  },
  created () {
    this.getNewList();
  },
  methods:{
    getNewList () {
      let self = this;
      const req = {
        index:1,
        size:10
      }
      console.log(this.id);
     this.$http.post('new/pageSelect/'+req.index+'/'+req.size,{id:self.id}).then((data)=>{
        data.body.data.forEach(element => {
          self.newList.img_url = element.img_url
          self.newList.describe = element.describe
          self.newList.title = element.title
        })
     })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
*{
  text-align: left;
  /*text-indent: 6px;*/
  font-family: 微软雅黑;
  letter-spacing: 1px;
  color: #2D2D2D;
  font-size: 12px;
  line-height: 22px;
}
h4{
  font-size: 16px;
  font-weight: border;
  color: black;
  text-align: center;
  margin-bottom: 20px;
  margin-top: 20px;
}
ul li{
  list-style-type: none;
  vertical-align: right;
}

.eq-header img{
  width: 97%;
}

</style>



// WEBPACK FOOTER //
// src/components/detail/newsListDetail.vue